import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { updateSectionFourRecord } from "../utils/update-section-four-record";

interface IRequest {
  mainJournalId: string;
  section4Id: string;
  section4ListId: string;
  itemPartOne: {
    isDefects: boolean;
    constructionControlInfo: string;
    controlEventPeriod: {
      beginDate: string;
      endDate: string;
    };
    defectsAbsenceRecord: string;
    defectFixingPlanDate?: string;
    defectDescriptionText?: string;
    docs?: Array<any>;
    works?: Array<any>;
    otherDocuments?: Array<any>;
    structuralElementName?: string;
    locationDescription?: string;
    locationType?: string;
    inspectionEmployeeId: string;
  };
}

export function useUpdateSectionFourEntry({
  section4ListId,
  itemNoVersionId,
}: {
  section4ListId: string;
  itemNoVersionId?: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: itemNoVersionId
      ? (data: IRequest) =>
          updateSectionFourRecord({
            itemNoVersionId,
            updateSectionFourRequest: data,
          })
      : async () => {},
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({ section4ListId }).queryKey,
      });
      if (itemNoVersionId) {
        queryClient.setQueryData(
          journalsQueries.getSectionFourItem({ itemNoVersionId }).queryKey,
          data,
        );
      }
      notification.success({
        message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
        description: NOTIFICATION_MESSAGES.ENTRY_UPDATED_DESC, // "Запись обновлена"
      });
    },
    onError: () => {
      notification.error({
        message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
        description: NOTIFICATION_MESSAGES.ENTRY_UPDATE_FAILED_DESC, // "Не удалось обновить запись"
      });
    },
  });
}

